import {createAction} from '@reduxjs/toolkit';

export const pinMap = createAction('PIN_MAP');

export const clearMapPin = createAction('CLEAR_PIN_MAP');

export const fitExtent = createAction('FIT_MAP_EXTENT');

export const setDrawTool = createAction('SET_DRAW_TOOL');

export const setCenterMarkerCoord = createAction('map/setCenterMarkerCoord');

export const setFeature = createAction('map/feature');

export const setIsOverZoomed = createAction('map/isOverzoomed');
